const styles = (theme) => ({
  root: {},
  bodyContainer: {
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing.unit * 2.5,
    },
  },
  avatar: {
    marginTop: '0px',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
    },
    color: theme.palette.custom.tenancy,
  },
});

export default styles;
